export const pricify = (value) => {
  return parseFloat(value || 0).toFixed(2)
}
